module.exports = __webpack_public_path__ + "./fonts/Gilroy-Medium.ttf";